import { render, staticRenderFns } from "./VideoChat.vue?vue&type=template&id=81237bea&"
import script from "./VideoChat.vue?vue&type=script&lang=js&"
export * from "./VideoChat.vue?vue&type=script&lang=js&"
import style0 from "./VideoChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports